/**
 * Custom Product Gallery Script
 * Reorganizes product gallery to have fixed first image with scrolling additional images
 * Safe to keep during theme upgrades - loaded via custom-product-gallery-assets.liquid snippet
 */

(function() {
  'use strict';

  function initCustomProductGallery() {
    const productGallery = document.querySelector('.shopify-section--main-product .product-gallery');
    
    if (!productGallery) {
      return;
    }

    const carousel = productGallery.querySelector('.product-gallery__carousel');
    
    if (!carousel) {
      return;
    }

    // Only apply on desktop (1000px and above)
    if (window.innerWidth < 1000) {
      return;
    }

    const mediaItems = carousel.querySelectorAll('.product-gallery__media');
    
    if (mediaItems.length <= 1) {
      return; // No need to reorganize if there's only one image
    }

    // Check if already reorganized
    if (carousel.querySelector('.product-gallery__scrolling-images')) {
      return;
    }

    // Create a container for scrolling images (all except first)
    const scrollingContainer = document.createElement('div');
    scrollingContainer.className = 'product-gallery__scrolling-images';

    // Move all images except the first into the scrolling container
    const mediaArray = Array.from(mediaItems);
    mediaArray.forEach((media, index) => {
      if (index > 0) {
        scrollingContainer.appendChild(media);
      }
    });

    // Append scrolling container after the first image
    if (mediaArray.length > 0) {
      carousel.appendChild(scrollingContainer);
    }
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomProductGallery);
  } else {
    initCustomProductGallery();
  }

  // Re-initialize on window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initCustomProductGallery();
    }, 250);
  });

  // Re-initialize when variant changes (for variant-specific images)
  document.addEventListener('variant:change', function() {
    setTimeout(initCustomProductGallery, 100);
  });

})();
